import { AGENT_USERS_FETCHED, LOG_OUT } from "../types";

const INITIAL_STATE = [];

export default function agentUsers(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case AGENT_USERS_FETCHED:
      return action.data;
    case LOG_OUT:
      return INITIAL_STATE;
    default:
      return state;
  }
}
